import { useUsuarioEmpresaActiva } from "api/Usuario.hook"
import { useCallback, useEffect, useState } from "react"
import { KEYS, getDataToSendToExternalApp } from "./constants"

const useRedirectToExternalApp = (customAppKey: $TSMigrationFixMe) => {
  const [aplicationKey, setAplicationKey] = useState(
    customAppKey || KEYS.GEFINTECH
  )
  const [showLoader, setShowLoader] = useState()
  const [progressValue, setProgressValue] = useState(0)
  const [initProgressValue, setInitProgressValue] = useState(true)
  const [showModal, toggleShowModal] = useState(false)
  const [message, setMessage] = useState("")
  const { activeCompany: empresaActiva } = useUsuarioEmpresaActiva()

  const handleAplications = (appKey: $TSMigrationFixMe) => {
    setAplicationKey(appKey)
    // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
    toggleShowModal()
  }
  // TODO: this code will be removed in the future, when the finanway migration is done

  const connectGeFintech = useCallback(() => {
    if (initProgressValue && showModal) {
      getDataToSendToExternalApp(
        empresaActiva?.nif,
        setShowLoader,
        setInitProgressValue,
        setMessage,
        setProgressValue,
        aplicationKey
      )
    }
  }, [initProgressValue, showModal, aplicationKey, empresaActiva?.nif])

  useEffect(() => {
    connectGeFintech()
  }, [connectGeFintech])

  return {
    showLoader,
    aplicationKey,
    message,
    progressValue,
    showModal,
    handleAplications,
    toggleShowModal,
  }
}

export default useRedirectToExternalApp
